import { useIntl } from 'react-intl'
import FilterChip from 'LuxKit/Chips/FilterChip'
import LineLandmarkIcon from 'LuxKit/Icons/line/LineLandmarkIcon'

// Toggle state threaded from the search page into the filter-row components.
export interface ExperienceLandmarksToggleState {
  show: boolean;
  active: boolean;
  onToggle: () => void;
}

interface Props {
  active: boolean;
  onToggle: () => void;
}

function ExperienceSearchLandmarksToggle({ active, onToggle }: Props) {
  const intl = useIntl()
  const label = intl.formatMessage({
    id: 'yrZfjSAAyVgOj4pACh-N',
    defaultMessage: 'Landmarks',
    description: 'Toggle button to show or hide the landmarks surface on the experience search page',
  })

  return (
    <FilterChip
      size="medium"
      selected={active}
      onClick={onToggle}
      startIcon={<LineLandmarkIcon />}
    >
      {label}
    </FilterChip>
  )
}

export default ExperienceSearchLandmarksToggle
